<script>
import Layout from "@/router/layouts/store";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";
import Qty from "@/components/widgets/store-qty";
import Shipping from "@/components/widgets/store-shipping";

export default {
  locales: {
    pt: {
      'Cart': 'Carrinho',
      'You are saving': 'Você está economizando',
      'on your order!': 'em seu pedido!',
      'Your cart is empty.': 'Seu carrinho está vazio.',
      'Product': 'Produto',
      'Qty': 'Qtd',
      'Price': 'Preço',
      'Total': 'Total',
      'This product is no longer available': 'Este produto não está mais disponível',
      'Delivery Time': 'Prazo de Entrega',
      'Pickup Address': 'Endereço de Retirada',
      'Order Summary': 'Resumo do Pedido',
      'Points': 'Pontos',
      'product': 'produto',
      'products': 'produtos',
      'Shipping': 'Frete',
      'Discount': 'Desconto',
      'Complete Purchase': 'Finalizar Compra',
      'Unable to complete your purchase, please try again.': 'Não foi possível finalizar sua compra, tente novamente.',
      'Your order must be at least %amount%.': 'O seu pedido deve ser de pelo menos %amount%.',
      'Choose an address for your order.': 'Escolha um endereço para o seu pedido.',
      'Choose a delivery method for your order.': 'Escolha um método de entrega para o seu pedido.',
      'The minimum amount for your first purchase is %amount%.': 'O valor mínimo da primeira compra é de %amount%.',
      'Some items in your cart are no longer available.': 'Alguns itens em seu carrinho não estão mais disponíveis.',
      'You need to select at least %points% points for %name%': 'Você precisa selecionar pelo menos %points% pontos para o %name%',
    },
    es: {
      'Cart': 'Carrito',
      'You are saving': 'Estás ahorrando',
      'on your order!': 'en tu pedido!',
      'Your cart is empty.': 'Tu carrito está vacío.',
      'Product': 'Producto',
      'Qty': 'Cant.',
      'Price': 'Precio',
      'Total': 'Total',
      'This product is no longer available': 'Este producto ya no está disponible',
      'Delivery Time': 'Plazo de Entrega',
      'Pickup Address': 'Dirección de Retiro',
      'Order Summary': 'Resumen del Pedido',
      'Points': 'Puntos',
      'product': 'producto',
      'products': 'productos',
      'Shipping': 'Envío',
      'Discount': 'Descuento',
      'Complete Purchase': 'Finalizar Compra',
      'Unable to complete your purchase, please try again.': 'No fue posible finalizar tu compra, inténtalo de nuevo.',
      'Your order must be at least %amount%.': 'Tu pedido debe ser de al menos %amount%.',
      'Choose an address for your order.': 'Elige una dirección para tu pedido.',
      'Choose a delivery method for your order.': 'Elige un método de entrega para tu pedido.',
      'The minimum amount for your first purchase is %amount%.': 'El monto mínimo para tu primera compra es de %amount%.',
      'Some items in your cart are no longer available.': 'Algunos artículos de tu carrito ya no están disponibles.',
      'You need to select at least %points% points for %name%': 'Necesitas seleccionar al menos %points% puntos para %name%',
    }
  },
  components: {
    Layout,
    VclList,
    Qty,
    Shipping,
  },
  data() {
    return {
      cart: {
        items: {
          loading: true,
          total: 0,
          list: null
        },
        points: {
          binary: 0,
          unilevel: 0,
          graduation: 0,
        },
        subtotal: '0.00',
        sale: '0.00',
        shipping: {
          method: '',
          value: '0.00',
        },
        discount: '0.00',
        total: '0.00',
        saving: '0.00',
      },
      checkout: {
        loading: false,
        errored: false,
        empty: false,
      },
    };
  },
  methods: {
    getCart() {
      this.cart = this.$children[0].cart
    },
    checkoutCart() {
      this.checkout.loading = true

      api
        .post('store/checkout')
        .then(response => {
          if (response.data.status == 'success') {
            localStorage.removeItem('cart');
            this.$children[0].getCart()
            this.getCart()

            this.$router.push('/store/order/' + response.data.order.id);
          } else if (response.data.status == 'inventory') {
            localStorage.removeItem('cart');
            this.$children[0].getCart()
            this.getCart()

            this.$toast.info(this.t(response.data.message))
          } else {
            let message = this.t(response.data.message)
            if (response.data.amount) message = message.replace('%amount%', response.data.amount)
            if (response.data.points) message = message.replace('%points%', response.data.points).replace('%name%', response.data.name)

            this.$toast.error(message)
          }
        })
        .catch(error => {
          this.checkout.errored = error
          this.checkout.loading = false
          this.$toast.error(this.t('Unable to complete your purchase, please try again.'))
        })
        .finally(() => {
          this.checkout.loading = false
        })
    },
  },
  computed: {
    getSubtotal() {
      return this.cart.subtotal
    },
    getShipping() {
      return this.cart.shipping.value
    },
    getDiscount() {
      return this.cart.discount
    },
    getTotal() {
      return parseFloat(this.getSubtotal) + parseFloat(this.getShipping) - parseFloat(this.getDiscount)
    },
    getSaving() {
      return this.cart.saving
    },
  },
  mounted() {
    this.getCart()
  }
};
</script>

<template>
  <Layout ref="store">
    <template v-if="cart.saving > 0">
      <div class="alert alert-info d-flex justify-content-center align-items-center">
        <div class="mr-2">
          <i class="bx bxs-offer font-size-24 align-bottom"></i>
        </div>
        <div>
          {{ t('You are saving') }} {{ getSaving | currency }} {{ t('on your order!') }}
        </div>
      </div>
    </template>
    <div class="row">
      <div :class="[cart.items.total > 0 ? 'col-md-7 col-lg-8' : 'col-md-12']">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <vcl-list v-if="cart.items.loading" class="col-lg-6"></vcl-list>
              <div v-else-if="cart.items.total == 0" class="text-center py-5">
                <i class="far fa-sad-cry font-size-24"></i><br>
                {{ t('Your cart is empty.') }}
              </div>
              <table v-else class="table table-centered table-nowrap">
                <thead>
                  <tr>
                    <th class="border-0" colspan="2">{{ t('Product') }}</th>
                    <th class="border-0 text-center">{{ t('Qty') }}</th>
                    <th class="border-0 text-center">{{ t('Price') }}</th>
                    <th class="border-0 text-center">{{ t('Total') }}</th>
                    <th class="border-0 text-center">PG</th>
                    <th class="border-0 text-center">PV</th>
                  </tr>
                </thead>
                <tbody v-if="cart.items.total > 0">
                  <tr v-for="(item, id) in cart.items.list" :key="id">
                    <td>
                      <img v-if="item.image" style="width:80px; height:80px; object-fit: cover;" class="" :src="item.image" />
                    </td>
                    <td class="font-weight-medium">
                      {{ item.name }}
                      <span v-if="item.inventory == 0" class="font-weight-normal font-size-12 text-danger text-uppercase">
                        <br>{{ t('This product is no longer available') }}
                      </span>
                      <!-- <span v-else-if="item.quantity > item.inventory" class="font-weight-normal font-size-12 text-danger text-uppercase">
                        <br>restam apenas {{ item.inventory }} produto
                      </span> -->
                    </td>
                    <td class="text-center">
                      <Qty :id="id" :quantity="item.quantity"></Qty>
                    </td>
                    <td class="text-center">{{ item.price | currency }}</td>
                    <td class="text-center">{{ item.subtotal | currency }}</td>
                    <td class="text-center">
                      <span v-if="item.points && item.points.graduation > 0" class="bg-default rounded-lg text-white p-2">{{ item.points.graduation }}</span>
                      <span v-else>-</span>
                    </td>
                    <td class="text-center">
                      <span v-if="item.points && item.points.binary > 0" class="bg-soft-info rounded-lg p-2">{{ item.points.binary }}</span>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="cart.items.total > 0" class="col-md-5 col-lg-4">
        <div v-if="cart.shipping.type == 'receive'" class="card">
          <div class="card-body">
            <h5 class="mb-3">{{ t('Delivery Time') }}</h5>
            <Shipping></Shipping>
          </div>
        </div>
        <div v-else-if="cart.shipping.type == 'withdraw'" class="card">
          <div class="card-body">
            <h5 class="mb-3">{{ t('Pickup Address') }}</h5>
            <div v-if="cart.shipping.address.address" class="bg-soft-warning rounded p-3">
              {{ cart.shipping.address.address }},
              {{ cart.shipping.address.number }},
              <template v-if="cart.shipping.address.complement">{{ cart.shipping.address.complement }},</template>
              {{ cart.shipping.address.city }}/{{ cart.shipping.address.state }},
              {{ cart.shipping.address.zipcode }}
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3">{{ t('Order Summary') }}</h5>
            <div class="d-flex mb-0 bg-soft-info rounded p-2 font-weight-medium" v-if="cart.points.graduation > 0">
              <div class="flex-fill">
                <span>PG</span>
              </div>
              <div class="flex-fill text-right">
                <span>{{ cart.points.graduation }}</span>
              </div>
            </div>
            <div class="d-flex mb-1 p-2" v-if="cart.points.binary > 0">
              <div class="flex-fill">
                <span>PV</span>
              </div>
              <div class="flex-fill text-right">
                <span>{{ cart.points.binary }}</span>
              </div>
            </div>
            <div class="d-flex" v-if="cart.points.unilevel > 0">
              <div class="flex-fill">
                <h6 class="mb-0">{{ t('Points') }}</h6>
              </div>
              <div class="flex-fill text-right">
                <h6 class="mb-0">{{ cart.points.unilevel }}</h6>
              </div>
            </div>
            <hr>
            <div class="d-flex mb-2">
              <div class="flex-fill">
                <span v-if="cart.items.total <= 1">
                  {{ cart.items.total }} {{ t('product') }}
                </span>
                <span v-else-if="cart.items.total > 1">
                  {{ cart.items.total }} {{ t('products') }}
                </span>
              </div>
              <div class="flex-fill text-right">
                {{ getSubtotal | currency }}
              </div>
            </div>
            <div class="d-flex mb-1 text-muted" v-if="cart.shipping.type == 'receive'">
              <div class="flex-fill">
                {{ t('Shipping') }}
              </div>
              <div class="flex-fill text-right">
                <div v-if="cart.shipping.method === ''">
                  -
                </div>
                <div v-else>
                  {{ cart.shipping.value | currency }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2 text-info" v-if="cart.discount > 0">
              <div class="flex-fill">
                {{ t('Discount') }}
              </div>
              <div class="flex-fill text-right">
                - {{ cart.discount | currency }}
              </div>
            </div>
            <div class="d-flex">
              <div class="flex-fill">
                <h6 class="mb-0">{{ t('Total') }}</h6>
              </div>
              <div class="flex-fill text-right">
                <h6 class="mb-0">{{ getTotal | currency }}</h6>
              </div>
            </div>
            <hr>
            <button v-on:click="checkoutCart()" class="btn btn-default btn-block font-weight-medium text-uppercase py-2" :disabled="checkout.loading">
              <i class="bx bx-basket font-size-24 align-middle pb-1"></i>
              {{ t('Complete Purchase') }}
              <b-spinner v-if="checkout.loading" small class="align-middle" variant="secondary" role="status"></b-spinner>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>